module.exports = __webpack_public_path__ + "img/wechat_light_normal.e2a203e3.svg";